import React from 'react';
import './AlertsPage.scss';
import search from '../../Assets/Icon/search.svg';
import { InputBox } from '../../Components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import success from '../../Assets/Icon/success.png';

import { getAlertsAction, alertInterestAction } from '../../Redux/Actions';
import { toast } from 'react-toastify';

class AlertsPage extends React.Component {
    state = {
        Alerts: [],
        searchText: '',
        depth: 0,
        selectedAlert: {},
        comment: '',
    }

    static getDerivedStateFromProps(props, state) {
        return {
            depth: props.depth
        }
    }
    
    componentDidMount() {
        this.props.getAlertsAction().then(()=>{
            const {alert_list} = this.props;
            if(alert_list){
                this.setState({Alerts: alert_list})
                if (this.props.match.params.id) {
                    let index = alert_list.findIndex(temp => temp.id === parseInt(this.props.match.params.id, 10));
                    this.selectAldert(alert_list[index]);
                }
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id) {
            let index = this.state.Alerts.findIndex(temp => temp.id === parseInt(this.props.match.params.id, 10));
            this.selectAldert(this.state.Alerts[index]);
        }
    }

    selectAldert = async (alert) => {
        let temp = alert || {};
        this.setState({ 
            selectedAlert: temp,
            comment: ''
        });
        await this.props.formatTitle();
        this.props.updateTitle('push', alert.name, 2);
    }

    showInterest = (id, interest) => {
        this.props.loader(true);
        const formData = new FormData();
        formData.append('alert_id', id);
        formData.append('is_interested', interest);
        formData.append('comment', this.state.comment);
        this.props.alertInterestAction(formData).then(()=>{
            this.props.loader(false);
            const {interestUpdateStatus, interestUpdateErr} = this.props
            if(!interestUpdateStatus.error){
                this.state.selectedAlert.response = {
                    is_interested: interest? 1 : 0,
                    comment: this.state.comment
                }
                this.setState({selectedAlert: this.state.selectedAlert})
                this.props.getAlertsAction();
                toast("Successfully updating!")
            } else {
                toast(interestUpdateStatus.message)
            }
        });        
    }

    render() {
        const { searchText, depth, selectedAlert, Alerts, comment } = this.state;
        const list = Alerts.filter(alert => alert.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1);
        return (
            <div className="alerts-page">
                <div className={`tutor-list v-r ${depth === 0 ? 'activate' : ''}`}>
                    <InputBox className="search-contact" value={searchText} icon={search} placeholder="Search..." onChange={val=>this.setState({searchText:val})} />
                    <div className="tutors v-r scroll-area">
                        {list.map((item, index) => <div className={`tutor-container ${selectedAlert.id === item.id ? 'selected' : ''}`} key={index} onClick={e => this.selectAldert(item)}>
                            <div className="tutor v-c">
                                <div className="info v-r">
                                    <h4>{item.name}</h4>
                                    <div className="info-time-status">
                                        <p>{moment(item.created_at.date).format('MMM DD, YYYY')}</p>
                                        {item.response.is_interested == undefined ? <p className="status-open">Open</p> : <p className="status-closed">You responded</p>}
                                    </div>
                                    <p></p>
                                </div>
                            </div>
                        </div>)}
                    </div>
                </div>
                <div className={`content-area v-r ${depth >= 1 ? 'activate' : ''}`}>
                    {selectedAlert.response && <div className="tutor-content v-r v-c h-c">
                        <h3>{selectedAlert.name}</h3>
                        <p>{selectedAlert.content}</p>
                        {selectedAlert.response.is_interested !== undefined && 
                            <React.Fragment>
                                <img src={success} alt="success" />
                                <h4>You clicked "{selectedAlert.response.is_interested === 1 ? 'Interested' : 'Not Interested'}"</h4>
                                {selectedAlert.response.is_interested === 1 ? 
                                    <p>If you're selected for the job, the admin will contact you.</p>
                                    : 
                                    <p>You will not be considered for this job.</p>
                                }
                                <p>You can still change your response</p>
                            </React.Fragment>
                        }
                        <textarea className="alert-comment" placeholder="Type your comment(optional)" value={comment} onChange={e => this.setState({ comment: e.target.value })} />
                        <div className="btn-area">
                            <button className="btn-2 primary-btn interest-btn" onClick={e => this.showInterest(selectedAlert.id, true)}>I am interested</button>
                            <button className="btn-2 btn-2-outline interest-btn" onClick={e => this.showInterest(selectedAlert.id, false)}>I am not interested</button>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    alert_list: state.Core.alert_list,
    interestUpdateStatus: state.Auth.interestUpdateStatus,
    interestUpdateErr: state.Auth.interestUpdateErr,
});

export default connect(mapStateToProps, { 
    getAlertsAction,
    alertInterestAction,
})(withRouter(AlertsPage));